import { type ProductSearchLocationItem } from '../../shared/types';
import { DistanceBoundaryInKm } from '../types/enums/distanceBoundaryInKm';

export type SearchReducerState = ProductSearchLocationItem;

export type SearchReducerAction = {
    type: SearchReducerActionType;
    value?: ProductSearchLocationItem;
};

export enum SearchReducerActionType {
    Location = 'location',
    Distance = 'distance',
    LocationFilterReset = 'locationFilterReset',
}

export function searchReducer(
    state: SearchReducerState,
    action: SearchReducerAction,
): ProductSearchLocationItem {
    switch (action.type) {
        case SearchReducerActionType.Location: {
            return {
                ...state,
                lat: action?.value?.lat,
                long: action?.value?.long,
                name: action?.value?.name,
                distance: action?.value?.distance,
            };
        }

        case SearchReducerActionType.Distance: {
            return {
                ...state,
                distance: action?.value?.distance,
            };
        }

        case SearchReducerActionType.LocationFilterReset: {
            return {
                distance: DistanceBoundaryInKm.DEFAULT,
            };
        }

        default: {
            throw new Error(`Unhandled action type: ${action.type as string}`);
        }
    }
}
